module.exports = __webpack_public_path__ + "static/img/jkfxts_icon.png";